export enum DeviceClassification {
  NEW_DEVICE = "NEW_DEVICE",
  REPLACEMENT = "REPLACEMENT",
}
